<template>
  <div id="app" v-bind:class="{ 'narrow-page': onNarrowPage }">
<!--<ppt-navbar></ppt-navbar> -->
    <div class="container">
      <router-view
        v-on:createSharableUrl="createSharableUrl($event)"
        v-on:saveScenario="expandSaveScenarioModal($event)"
        v-on:updateScenario="updateScenario($event)"
      ></router-view>
    </div>
<!--     <ppt-footer></ppt-footer> -->
    <sharable-url-modal
      v-bind:url="sharableUrl.url"
      v-bind:approximateWaitTime="sharableUrl.approximateWaitTime"
    />
    <save-scenario-modal
      v-on:save="saveScenario($event)"
    />
  </div>
</template>

<script>
  import PPTNavbar from '@/components/navbar';
  import PPTFooter from '@/components/footer';
  import SharableUrlModal from '@/components/sharable-url-modal';
  import SaveScenarioModal from '@/components/save-scenario-modal';
  import shareUrlService from '@/services/share-url-service';
  import utilities from '@/services/utilities/utilities';

  export default {
    name: 'app',
    components: {
      'ppt-navbar': PPTNavbar,
      'ppt-footer': PPTFooter,
      'sharable-url-modal': SharableUrlModal,
      'save-scenario-modal': SaveScenarioModal,
    },
    data: function () {
      return {
        sharableUrl: {
          url: null,
          approximateWaitTime: null,
        },
        saveScenarioVariables: {
          method: null,
          propertyName: null,
          state: null,
        },
      };
    },
    computed: {
      onNarrowPage: function () {
        return !!this.$route.meta.narrow;
      },
    },
    methods: {
      createSharableUrl: function (payload) {
        let self = this;

        $(self.$el).find('.sharable-url-modal').modal();
        self.sharableUrl.url = '';
        self.approximateWaitTime = payload.approximateWaitTime ? payload.approximateWaitTime : null;
        shareUrlService[payload.method](payload.state)
          .then(function (response) {
            if (response.data.url) {
              self.sharableUrl.url = response.data.url;

              if (response.data.approximateWaitTime) {
                self.sharableUrl.approximateWaitTime = response.data.approximateWaitTime;
              }
            } else {
              alert('Didn\'t get url back from server.');
              throw new Error('Didn\'t get url back from server.');
            }
          })
          .catch(function () {
            alert('Problem trying to create the sharable URL.');
            throw new Error('Problem trying to create the sharable URL.');
          })
        ;
      },

      expandSaveScenarioModal: function (payload) {
        $(this.$el).find('.save-scenario-modal').modal();
        this.saveScenarioVariables.method = payload.method;
        this.saveScenarioVariables.propertyName = payload.savedScenarioPropertyName;
        this.saveScenarioVariables.state = payload.state;
      },
      saveScenario: function (title) {
        let self = this;
        let savedScenarioUrl;

        shareUrlService[self.saveScenarioVariables.method](self.saveScenarioVariables.state)
          .then(function getUrlForSavedScenario (response) {
            if (response.data.url) {
              return response.data.url;
            } else {
              alert('Problem trying to save the scenario.');
              throw new Error('Didn\'t get url back from server.');
            }
          })
          .then(function updateUserOnServer (url) {
            let newSavedScenarios = self._getNewSavedScenarios(title, url);
            let user = _.cloneDeep(self.$store.state.account.user);

            savedScenarioUrl = url;
            user.savedScenarios = newSavedScenarios;

            return self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user });
          })
          .then(function updateUserOnClient (res) {
            self.$store.commit('account/setUser', res.data.user);
            alert('Saved!');
            window.location.href = savedScenarioUrl;
          })
          .catch(function () {
            alert('Problem trying to save the scenario.');
            throw new Error('Problem trying to save the scenario.');
          })
        ;
      },
      _getNewSavedScenarios: function (title, url) {
        let newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

        newSavedScenarios[this.saveScenarioVariables.propertyName].push({
          title: title,
          url: url,
        });

        return newSavedScenarios;
      },
      updateScenario: function (payload) {
        let storeState = shareUrlService[payload.method](payload.state);

        this.$http.put(`${process.env.BASE_API_URL}/update-sharable-url/` + this.$route.params.id, storeState)
          .then(function () {
            alert('Successfully updated scenario.');
          })
          .catch(function () {
            alert('Error: unable to update scenario. Email contact@sixplusholdem.com for assistance.');
          })
        ;
      },
    },
  };
</script>

<style lang="scss">
  $icon-font-path: "~bootstrap-sass/assets/fonts/bootstrap/";
  $font-size-base: 12px;
  $grid-gutter-width: 15px;
  $container-large-desktop: 100%;
  @import "node_modules/bootstrap-sass/assets/stylesheets/bootstrap";
  @import "node_modules/@geedmo/yamm3/yamm/yamm.scss";
  @import "src/assets/app";
  @import "src/assets/bootstrap-social";

  .narrow-page {
    font-size: 18px;

  }
</style>



// WEBPACK FOOTER //
// src/App.vue